
export const mobileNumberMixins = {
	methods: {
		formatMobileNumber(value) {
			let data = value.split('');
			data.splice(4, 0, '-');
			return data.join('');
		}
	}
}